/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export * from './AreaFragmentDto';
export * from './FrameSupportedSizeDto';
export * from './StubbedDto';
export * from './CheeksDto';
export * from './FrameSurroundingRodDto';
export * from './FrameOverlaysDto';
export * from './SplinterDto';
export * from './RoofTrimDto';
export * from './FrameDto';
export * from './Material';
